<div class="container-fluid">
    <input type="text" class="form-control w-100" name="answer_{{name}}" placeholder="{{placeholder}}" required
        [(ngModel)]="value" [ngbTypeahead]="search">
    <div style="padding-top: 5px;">
        <mrs-btn-primary buttonLabel="Submit" buttonId="goHomeBtn" (onClick)="onClick()"
            [disabled]="disabled"></mrs-btn-primary>
    </div>
</div>